<template>
	<AppContentLayout class="alerts-view">
		<div class="top-section flex-centerize">
			<div class="top-section-content width-100">
				<AppTabs :tabItems="tabItems" />
			</div>
		</div>
	</AppContentLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { getActiveAlerts } from '@/store/modules/alerts/getters';
import AppContentLayout from '../AppLayout/AppContentLayout';
import UserAlertsTab from '@/components/Alerts/tabs/UserAlertsTab';
import { getUserAlerts } from '@/store/modules/alerts/actions';

export default {
	name: 'Alerts',
	props: {},
	components: {
		AppContentLayout,
	},
	computed: {
		...mapGetters([getActiveAlerts.fullPath]),
		activeAlerts() {
			return this[getActiveAlerts.fullPath] || [];
		},
		tabItems() {
			return [
				{ tab: 'alerts', title: `Alerts (${this.activeAlerts.length})`, component: UserAlertsTab, props: { showArchivedAlerts: false } },
				{ tab: 'archived', title: 'Archived', component: UserAlertsTab, props: { showArchivedAlerts: true } },
			];
		},
	},
	methods: {
		...mapActions([getUserAlerts.fullPath]),
	},
	mounted() {
		this[getUserAlerts.fullPath]();
	},
	data() {
		return {
			localTab: 0,
		};
	},
};
</script>

<style scoped lang="scss">
.alerts-view {
	overflow-y: auto;

	.top-section {
		font-size: 16px;
		font-weight: 700;

		.top-section-content {
			max-width: 1025px;
		}
	}
}
</style>
